import { format, parse } from "date-fns";

export function formatTooltipHeader(label: string): string {
    try {
      const parsed = parse(label, "MMM d", new Date());
      return format(parsed, "d MMMM yyyy");
    } catch {
      return label;
    }
  }